import api from './../helpers/api'

class CustomerService {

    saveCustomer(customer) {
        return api.post('/save_customer', {
            name:         customer.name,
            address:      customer.address,
            contact:      customer.contact,
            email:        customer.email        || null,
            notes:        customer.notes        || null,
            credit_limit: customer.credit_limit || 0,
        });
    }

    editCustomer(customer) {
        return api.post('/edit_customer', {
            id:           customer.id,
            name:         customer.name,
            address:      customer.address,
            contact:      customer.contact,
            email:        customer.email        || null,
            notes:        customer.notes        || null,
            credit_limit: customer.credit_limit || 0,
        });
    }

    get_customerlist() {
        return api.get('/get_all_customers');
    }

    getProfile(id) {
        return api.get(`/customer_profile/${id}`);
    }

    updateCreditLimit(id, limit) {
        return api.post(`/update_credit_limit/${id}`, { credit_limit: limit });
    }

    redeemPoints(id, points) {
        return api.post(`/redeem_points/${id}`, { points });
    }

    payInvoice(saleId, amount) {
        return api.post(`/pay_invoice/${saleId}`, { amount });
    }

    get_customer_purchase(id) {
        return api.get(`/get_customer_purchase/${id}`);
    }

    get_customer_purchases(range, id) {
        return api.post(`/get_customer_purchases/${id}`, { range });
    }

    get_customers() {
        return api.get('/get_customers');
    }

    get_customer(id) {
        return api.post('/get_customer', { id });
    }

    save(id, remain, amount) {
        return api.post(`/save_paid/${id}`, { remain, amount });
    }

    get_paid_customers() {
        return api.get('/get_paid_customers');
    }

    view_customer_payments(id) {
        return api.get(`/view_customer_payments/${id}`);
    }

    get_debts() {
        return api.get('/get_debts', {});
    }

    paid_debts() {
        return api.get('/paid_debts', {});
    }

    save_paid_debt(id, account, amount, remain) {
        return api.post('/save_paid_debt', { id, remain, amount, account });
    }

    save_debt(debt) {
        return api.post('/save_new_debt', {
            name:        debt.name,
            amount:      debt.amount,
            description: debt.description,
        });
    }

    editPayment(payment) {
        return api.post('/edit_customer_payment', { id: payment.id, amount: payment.amount });
    }

    get_purchase_balance() {
        return api.get('/get_purchase_balance');
    }

    save_purchase_balance(id, remain, amount) {
        return api.post(`/save_purchase_balance/${id}`, { remain, amount });
    }

    view_payed_purchases(id) {
        return api.post(`/view_payed_purchases/${id}`);
    }

    get_paid_purchase_balance() {
        return api.get('/get_paid_purchase_balance');
    }

    refund(id, sold_id, quantity) {
        return api.post(`/refund/${id}`, { sold_id, quantity });
    }

    deleteTransaction(sale_id, customer_id) {
        return api.post('/delete_transaction', { sale_id, customer_id });
    }

    customersSales(start, end) {
        return api.post('/custo_sales', { start, end });
    }
}

export default new CustomerService;
